<template>
  <div class="container text-secondary">
    <div class="row mb-4">
      <div class="col-2"/>
      <div class="col">
        <img src="@/assets/team-100.png" alt="" class="img-fluid mt-0 d-inline-block opacity-75" style="height:40px;"/>
        <div class="h2 mt-2 d-inline-block">Spelers</div>
      </div>
      <div class="col-2 text-end pe-2">
        <img src="@/assets/back-48.png" alt="terug" class="img-fluid" style="height:32px; cursor:pointer;" @click="$router.push('/')"/>
      </div>
    </div>

    <hr class="divider">

    <div class="card-modern">
      <div class="row mb-3">
        <div class="col">
          Speler:
          <input type="text" class="form-control mt-1" v-model="name" placeholder="Naam van de speler" @keyup.enter="addPlayer"/>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col text-end">
          <img src="@/assets/add-user-female-100.png" alt="vrouw toevoegen" class="img-fluid" style="height:64px; cursor:pointer;" @click="addPlayer('female')"/>
        </div>
        <div class="col text-start">
          <img src="@/assets/add-user-male-100.png" alt="man toevoegen" class="img-fluid" style="height:64px; cursor:pointer;" @click="addPlayer('male')"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";

export default {
  name: "PlayerScreen",
  data() {
    return {
      name: '',
    };
  },
  methods: {
    addPlayer(gender) {
      if (!this.name.trim()) return;
      store.commit('addPlayer', {
        id: this.generateUUID(),
        name: this.name.trim(),
        gender: gender,
      });
      router.push('/');
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    },
  },
}
</script>